import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LOGGED_HOME_PAGE_PATH, PREVIOUS_URL_PATH } from "../../../constants/env";
import type { IBackNavigationConfig, IUseBackNavigation } from "./useBackNavigation.interface";

export function useBackNavigation(config?: IBackNavigationConfig): IUseBackNavigation {
  const navigate = useNavigate();
  const location = useLocation();

  const performBackNavigation = useCallback(
    function handleBackNavigation() {
      if (!config) {
        return;
      }

      if (typeof config.action === "function") {
        config.action();
        return;
      }

      if (config.url === PREVIOUS_URL_PATH) {
        const hasPreviousHistoryEntry = window.history.length > 1;
        if (hasPreviousHistoryEntry && location.key !== "default" && !location.state?.isDirectAccess) {
          navigate(-1);
        } else {
          navigate(config.defaultBackUrl ?? LOGGED_HOME_PAGE_PATH);
        }
        return;
      }

      if (typeof config.url === "string") {
        navigate(config.url, { replace: config.replace });
        return;
      }

      navigate(-1);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config, location.key, navigate]
  );

  return { performBackNavigation };
}
